import useAuth from 'hooks/useAuth';

/**
 * The user a settings page edits, when that is someone other than the person signed in — an
 * admin setting up a teammate. `undefined` on your own settings, so those keep calling the
 * session-scoped routes exactly as before.
 *
 * Settings saved through a session-scoped route (`/me`, or one keyed on the caller) used to land on
 * the admin's own account while reporting success (Rec0CB6ULP7C5). Pass this to those calls.
 */
const useTeammateId = (editedUserId?: string): string | undefined => {
  const { user } = useAuth();
  return editedUserId && editedUserId !== user?.id ? editedUserId : undefined;
};

export default useTeammateId;
